import React from 'react';
import API from '../../services/API';
import CustomStore from 'devextreme/data/custom_store';

import { Column, DataGrid, Paging, Editing } from 'devextreme-react/data-grid';
import useStyles from '../styles/styles';
import usePermissions from '../../hooks/usePermissions';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../global';
import { Template } from 'devextreme-react/core/template';

const holidays = new CustomStore({
  key: 'HolidayId',
  load: async () => {
    const { data } = await API.sendRequest(`Holiday`, 'get');
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`Holiday`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`Holiday`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`Holiday/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const Holiday = () => {
  const classes = useStyles();

  /** *******************************
   * Access Control
   ******************************** */
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <LoadPermissions>Loading permissions</LoadPermissions>;
  }
  if (ACL.NoAccess) {
    return (
      <LoadPermissions>You don't have access to this page</LoadPermissions>
    );
  }
  /** ****************************** */

  return (
    <div className={classes.divGridContainer}>
      <DataGrid
        id="gridContainer"
        dataSource={holidays}
        // keyExpr={'HolidayId'}
        allowColumnReordering
        showBorders
        rowAlternationEnabled
        focusedRowEnabled
        showRowLines
        onRowUpdating={onRowUpdating}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />
        <Editing
          useIcons
          mode="form"
          allowAdding={ACL.AddNew}
          allowUpdating={ACL.Update}
          allowDeleting={ACL.Delete}
        />

        <Column dataField="HolidayDate" caption="Date" dataType="date" />
        <Column dataField="HolidayDesc" caption="Holiday" />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default Holiday;
